import { useGateValue } from "@statsig/react-bindings";

/**
 * Custom hook to check if WCCS Autoreply (carousel preview) is enabled.
 * Returns a boolean indicating whether the "enable_wccs_autoreply"
 * feature gate is enabled on Statsig.
 */
export const useEnableWccsAutoreply = (): boolean => {
  return useGateValue("enable_wccs_autoreply");
};
